import React from "react";
import { Lightning, ArrowsClockwise, ShieldCheck } from "@phosphor-icons/react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";

const ICONS = [Lightning, ArrowsClockwise, ShieldCheck];

export default function OperatingModel() {
  const { t } = useLang();
  return (
    <section id="operating" data-testid="operating-section" className="relative py-24 lg:py-32 bg-surface overflow-hidden">
      <div className="absolute right-0 top-0 w-[36rem] h-[36rem] glow-gold rounded-full blur-3xl opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal><SectionLabel>{t.operating.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-6 tracking-[-0.01em]">{t.operating.title}</h2>
          </Reveal>
        </div>
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {t.operating.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08} y={50}>
                <div className="h-full border border-white/10 rounded-sm p-8 lg:p-10 bg-navy/50 hover:border-gold/40 transition-colors duration-500">
                  <div className="flex items-center gap-4">
                    <Icon weight="duotone" size={34} className="text-gold" />
                    <span className="font-serif text-gold/60 text-lg">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <h3 className="font-serif text-xl sm:text-2xl text-white mt-6">{item.title}</h3>
                  <p className="text-white/60 leading-relaxed mt-4">{item.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
